<ng-container *transloco="let t"
  ><xi-generic-modal
    [canBackdropClose]="false"
    [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
    [isVisible]="true"
    maxWidth="800px"
    (onClose)="cancel()"
  >
    <div slot="children">
      <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
        <div slot="children">
          <div class="xi-modal__container group-add__container">
            <h2 class="xi-modal__title">{{ t('group-add-dialog.add-to-group') }}</h2>

            <div class="group-add__content xi-modal__content">
              <div>
                <table
                  mat-table
                  [dataSource]="allGroups"
                  matSort
                  matSortActive="name"
                  matSortDirection="asc"
                  matSortDisableClear
                  class="full-width"
                >
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ t('group-add-dialog.name') }}
                    </th>

                    <td mat-cell *matCellDef="let element">{{ element.group_name }}</td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    [class.group-add__group--selected]="isGroupSelected(row)"
                    (click)="!isSaving && selectGroup(row)"
                  ></tr>
                </table>
              </div>
            </div>

            <div class="xi-modal__actions group-add__actions">
              <xi-default-button
                text="{{ t('group-add-dialog.cancel') }}"
                fill="text"
                (onClick)="cancel()"
              ></xi-default-button>
              <div class="xi-loader-button-container">
                <xi-default-button
                  text="{{ t('group-add-dialog.add') }}"
                  [disabled]="!selectedGroups.length || isSaving"
                  (onClick)="add()"
                ></xi-default-button>
                @if (isSaving) {
                  <div class="xi-loader-container__inline-overlay">
                    <xi-animation
                      [height]="75"
                      [width]="75"
                      [loop]="true"
                      animation="cx_loader"
                    ></xi-animation>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </xi-basic-tile>
    </div>
  </xi-generic-modal>
</ng-container>
